import OptionsContext from '../OptionsContext'
import { useContext } from 'react'

const useIsRightToLeft = () => {
  const { options } = useContext(OptionsContext)
  const textShouldRenderFromRightToLeft = options.language === 'ar'
  return textShouldRenderFromRightToLeft
}

export default useIsRightToLeft